(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('NomenclatureService', NomenclatureService);

    NomenclatureService.$inject = ['$http', 'API_URL', 'CartFactory', '$q'];

    function NomenclatureService($http, API_URL, CartFactory, $q) {

        var service = {
            loadNomenclature: loadNomenclature,
            postNomenclature: postNomenclature
        };

        return service;

        function loadNomenclature(coExhibitorId) {
            if (coExhibitorId) {
                var cartItems = CartFactory.getCart();

                var cartItemIndex = -1;
                for (var i = 0; i < cartItems.length; ++i) {
                    if (cartItems[i].type === 'CoExhibitorFee' && cartItems[i].cartPositionBookedForId === coExhibitorId) {
                        cartItemIndex = i;
                        break;
                    }
                }

                // var cartItemIndex = cartItems.findIndex(function (item) {
                //     return item.type === 'CoExhibitorFee' && item.cartPositionBookedForId === coExhibitorId;
                // });

                if (cartItemIndex >= 0) {
                    var cartItem = cartItems[cartItemIndex];

                    if (cartItem) {
                        return $q.resolve({
                            data: {
                                nomenclature: (cartItem.nomenclature || [])
                            }
                        });
                    }
                }

                return $q.resolve([]);
            } else {
                return $http({
                    method: 'GET',
                    url: API_URL + 'exhibitor/nomenclature'
                });
            }
        }

        function postNomenclature(coExhibitorId, data) {
            if (coExhibitorId) {
                var cartItems = CartFactory.getCart();

                var cartItemIndex = -1;
                for (var i = 0; i < cartItems.length; ++i) {
                    if (cartItems[i].type === 'CoExhibitorFee' && cartItems[i].cartPositionBookedForId === coExhibitorId) {
                        cartItemIndex = i;
                        break;
                    }
                }


                // var cartItemIndex = cartItems.findIndex(function (item) {
                //     return item.type === 'CoExhibitorFee' && item.cartPositionBookedForId === coExhibitorId;
                // });

                if (cartItemIndex >= 0) {
                    var cartItem = cartItems[cartItemIndex];

                    if (cartItem) {
                        cartItem.nomenclature = data;
                        CartFactory.updateItemByIndex(cartItemIndex, cartItem);

                        return $q.resolve(cartItem);
                    }
                }

                return $q.reject();
            } else {
                return $http({
                    method: 'POST',
                    url: API_URL + 'exhibitor/nomenclature',
                    data: {
                        nomenclature: data
                    }
                });
            }
        }
    }
})();
